'use client';

import React from 'react';

interface SortIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
}

export const SortIcon: React.FC<SortIconProps> = ({
  width = 20,
  height = 20,
  color = '#000',
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 20 20"
      className={className}
    >
      <path
        fill={color}
        d="M6.75 13.25H3.5l4.875 4.875V1.875H6.75zm4.875-8.937v13.812h1.625V6.75h3.25l-4.875-4.875z"
      />
    </svg>
  );
};

